import * as Guid from '@ms/utilities-guid/lib/Guid';

declare const window: Window & {
    'rootVector': CorrelationVector;
};

// Note: can be window or WorkerGlobalScope(in worker context).
declare const self: Window & {
    'rootVector': CorrelationVector;
};

export class CorrelationVector {
    public static RootVector: CorrelationVector = CorrelationVector._getCorrelationVector();

    public root: string;
    public parent: string;
    public current: string;

    private static _getCorrelationVector(): CorrelationVector {
        let rootVector;
        if (typeof window !== 'undefined') {
            rootVector = window.rootVector;
        } else if (typeof self !== 'undefined') {
            rootVector = self.rootVector;
        }
        return rootVector || new CorrelationVector();
    }

    constructor(
        parent?: {
            root: string,
            current: string
        },
        current?: string) {

        if (parent) {
            this.root = parent.root;
            this.parent = parent.current;
        } else {
            this.root = this.parent = Guid.Empty;
        }

        if (current) {
            this.current = current;
        } else {
            this.current = Guid.generate();
        }
    }

    public toString(): string {
        return `${this.root}#${this.parent}#${this.current}`;
    }
}
